import * as AppConstants from 'app/AppConstants';
import {NOT_LOADED, LOADING, FINISHED} from './featureConstants';

const initialState = () => ({
  status: NOT_LOADED,
  environmentFeatures: {},
  urlFeatures: {},
  sessionFeatures: {},
  switcherFeatures: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.ENVIRONMENT__LOAD_ENVIRONMENT_FINISHED: {
      const environmentFeatures = (action.payload.features || []).reduce(
        (memo, feature) => {
          memo[feature.name] = feature.enabled;
          return memo;
        },
        {}
      );

      return {
        ...state,
        environmentFeatures,
      };
    }

    case AppConstants.FEATURE__FEATURES_LOADED_BY_URL: {
      return {
        ...state,
        urlFeatures: action.payload.features,
      };
    }

    case AppConstants.FEATURE__FEATURES_LOADED_BY_SESSION: {
      return {
        ...state,
        sessionFeatures: action.payload.features,
      };
    }

    case AppConstants.FEATURE__FEATURES_LOADED_BY_SWITCHER: {
      return {
        ...state,
        switcherFeatures: action.payload.features,
      };
    }

    case AppConstants.FEATURE__LOAD_FEATURES_STARTED:
      return {
        ...state,
        status: LOADING,
      };
    case AppConstants.FEATURE__LOAD_FEATURES_FINISHED:
    case AppConstants.FEATURE__LOAD_FEATURES_FAILED:
      return {
        ...state,
        status: FINISHED,
      };

    default:
      return state;
  }
};
